const {
  calculateSIP,
  calculateLumpsum,
  calculateHRA,
} = require("../utils/formula");

const FORMULA = {
  SIP: "formula-fv-with-sip-payment",
  LUMPSUM: "formula-fv-with-lumpsum-payment",
  HRA: "formula-hra",
};

const FORMULA_LIST = {
  [FORMULA.LUMPSUM]: calculateLumpsum,
  [FORMULA.SIP]: calculateSIP,
  [FORMULA.HRA]: calculateHRA,
};

const YES = "Yes";

module.exports = {
  FORMULA,
  FORMULA_LIST,
  YES,
};
